var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCours(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.613,
    height: 81.151,
    viewBox: "0 0 56.613 81.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M10.19,4.08a3.18,3.18,0,0,0-3.73-1,2.91,2.91,0,0,0-1,.65,2.85,2.85,0,0,0-.63,1,3.05,3.05,0,0,0-.24,1.22,3.15,3.15,0,0,0,.24,1.24,2.86,2.86,0,0,0,.64,1,2.77,2.77,0,0,0,1,.65,3,3,0,0,0,1.2.24,3.36,3.36,0,0,0,2.52-1.19v3.46l-.3.11a7.67,7.67,0,0,1-1.25.35,6.48,6.48,0,0,1-1.15.11,5.74,5.74,0,0,1-2.24-.44,5.81,5.81,0,0,1-1.88-1.24,6.13,6.13,0,0,1-1.31-1.9,5.9,5.9,0,0,1-.49-2.39A5.81,5.81,0,0,1,3.36,1.67,5.72,5.72,0,0,1,5.25.44,5.93,5.93,0,0,1,7.5,0,6.6,6.6,0,0,1,8.83.14a8.54,8.54,0,0,1,1.36.44Z",
    fill: "#6a6664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M11.7,6A5.81,5.81,0,0,1,15.41.46a7.11,7.11,0,0,1,5,0,5.79,5.79,0,0,1,2,1.26A5.87,5.87,0,0,1,24.18,6a5.84,5.84,0,0,1-.47,2.33,5.67,5.67,0,0,1-1.29,1.89,6,6,0,0,1-2,1.27,7.25,7.25,0,0,1-5,0,6,6,0,0,1-2-1.27,5.67,5.67,0,0,1-1.29-1.89A5.84,5.84,0,0,1,11.7,6Zm3.06,0A3,3,0,0,0,15,7.19a3.37,3.37,0,0,0,.68,1,3.07,3.07,0,0,0,1,.65,3.35,3.35,0,0,0,2.44,0,3.19,3.19,0,0,0,1.71-1.63,3.012,3.012,0,0,0-.67-3.45,3.07,3.07,0,0,0-1-.65,3.35,3.35,0,0,0-2.44,0,3.07,3.07,0,0,0-1,.65,3.29,3.29,0,0,0-.68,1A3,3,0,0,0,14.76,6Z",
    fill: "#6a6664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M29,.31V7.44a2.76,2.76,0,0,0,.23.93,1.49,1.49,0,0,0,.59.68,2.586,2.586,0,0,0,2.26,0,1.62,1.62,0,0,0,.59-.68,2.55,2.55,0,0,0,.23-.93V.31h2.91V6.84a5.26,5.26,0,0,1-1.2,3.84,5,5,0,0,1-3.7,1.21,5,5,0,0,1-3.7-1.21A5.22,5.22,0,0,1,26,6.84V.31Z",
    fill: "#6a6664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M47.57,11.58H43.93l-2.8-4.33v4.33H38.2V.31h4.56A4.5,4.5,0,0,1,44.4.59a3.08,3.08,0,0,1,1.85,1.86,4,4,0,0,1,.23,1.34,3.33,3.33,0,0,1-.62,2.09A3.12,3.12,0,0,1,44,7ZM41.13,5.35h.55A2.11,2.11,0,0,0,43,5a1.22,1.22,0,0,0,.47-1A1.22,1.22,0,0,0,43,3a2.11,2.11,0,0,0-1.33-.36h-.55Z",
    fill: "#6a6664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M55,3.2a3.78,3.78,0,0,0-1-.58,2.57,2.57,0,0,0-.92-.19,1.51,1.51,0,0,0-.93.27.85.85,0,0,0-.36.71A.69.69,0,0,0,52,3.9a1.72,1.72,0,0,0,.47.34,5.06,5.06,0,0,0,.66.24l.73.23A4.45,4.45,0,0,1,55.94,6a3.14,3.14,0,0,1,.67,2.09,4.18,4.18,0,0,1-.29,1.57,3.5,3.5,0,0,1-.85,1.2,4.21,4.21,0,0,1-1.38.78,5.84,5.84,0,0,1-1.84.27,6.74,6.74,0,0,1-4-1.27L49.5,8.28a5.09,5.09,0,0,0,1.3.87,3.11,3.11,0,0,0,1.27.28,1.51,1.51,0,0,0,1.07-.33.958.958,0,0,0-.04-1.53,2.68,2.68,0,0,0-.54-.29L51.78,7c-.37-.12-.75-.25-1.11-.39a3.62,3.62,0,0,1-1-.58,2.84,2.84,0,0,1-.69-.9,3.3,3.3,0,0,1-.26-1.38A3.88,3.88,0,0,1,49,2.19,3.45,3.45,0,0,1,49.8,1,3.63,3.63,0,0,1,51,.27,4.59,4.59,0,0,1,52.65,0,7.32,7.32,0,0,1,54.4.23a7.93,7.93,0,0,1,1.75.68Z",
    fill: "#6a6664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M0,26V70.15a11,11,0,0,0,11,11H55.22a11.71,11.71,0,0,1,0-16.56V14.93H11A11,11,0,0,0,0,26Z",
    fill: "#6a6664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M49.7,59.1V20.45H11A5.52,5.52,0,0,0,5.52,26V60.64A10.92,10.92,0,0,1,11,59.1Z",
    fill: "#d4d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M5.52,70.15A5.52,5.52,0,0,0,11,75.67H46.51a17.31,17.31,0,0,1,1.89-11H11a5.52,5.52,0,0,0-5.48,5.48Z",
    fill: "#bfe3e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1043",
    "data-name": "Rectangle 1043",
    width: 30.37,
    height: 5.52,
    transform: "translate(13.8 25.97)",
    fill: "#6a6664"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1044",
    "data-name": "Rectangle 1044",
    width: 19.33,
    height: 5.52,
    transform: "translate(13.8 37.02)",
    fill: "#6a6664"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCours);
export default __webpack_public_path__ + "static/media/Cours.4bb56163.svg";
export { ForwardRef as ReactComponent };